import { ResourceOptions } from 'react-admin';
import { FaHistory } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxOpenSessions;
export const icon = FaHistory;
export const options: ResourceOptions = {
  label: 'module.blindBox.openSessions',
};

